<template>
    <v-app fluid>
        <v-app-bar fixed
                   app
                   color="#303030"
                   dark>
            <a href="https://ezzeseguros.com.br"
               x-large
               flat
               color="transparent">
                <v-img contain
                       max-width="180"
                       src="./assets/logo-ezze.png"></v-img>
            </a>

        </v-app-bar>
        <v-main>
            <v-container>
                <CadastroCorretor />
            </v-container>


        </v-main>
    </v-app>
</template>

<script>
    import CadastroCorretor from './components/CadastroCorretor';
    export default {
        name: 'App',

        components: {
            CadastroCorretor
        },

        data: () => ({

        }),
    };
</script>


<style>

    .theme--light.v-stepper,
    .v-stepper__header {
        box-shadow: none !important;
    }
</style>